export const getCourses = async (selectedClient) => {
  const results = await fetch(
    `${process.env.REACT_APP_REST_SERVER_URL}/admin/courses/${selectedClient.id}/list`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
    }
  );
  const response = await results.json();
  return response;
}


export const saveCourse = async (course, clientId) => {
};

export const getCourseInfo = async (courseId, client) => {
  const results = await fetch(
    `${process.env.REACT_APP_REST_SERVER_URL}/admin/courses/${client.id}/course/${courseId}/info`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
    }
  );
  const response = await results.json();
  return response;
}

export const getCourseLevels = async (courseId, client) => {
  const results = await fetch(
    `${process.env.REACT_APP_REST_SERVER_URL}/admin/courses/${client.id}/course/${courseId}/levels`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
    }
  );
  const response = await results.json();
  return response;
}

export const getCourseLevelInfo = async (courseLevelId, client) => {
  const results = await fetch(
    `${process.env.REACT_APP_REST_SERVER_URL}/admin/courses/${client.id}/courselevel/${courseLevelId}/info`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
    }
  );
  const response = await results.json();
  return response;
}

export const getLevelSectionInfo = async (levelSectionId, client) => {
  const results = await fetch(
    `${process.env.REACT_APP_REST_SERVER_URL}/admin/courses/${client.id}/levelsection/${levelSectionId}/info`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
    }
  );
  const response = await results.json();
  return response;
}

export const getLevelSectionContent = async (levelSectionId, client) => {
  const results = await fetch(
    `${process.env.REACT_APP_REST_SERVER_URL}/admin/courses/${client.id}/levelsection/${levelSectionId}/content`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
    }
  );
  const response = await results.json();
  return response;
}

export const getCourseUsers = async (courseId, client) => {
  const results = await fetch(
    `${process.env.REACT_APP_REST_SERVER_URL}/admin/courses/${client.id}/course/${courseId}/users`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
    }
  );
  const response = await results.json();
  return response;
}

export const assignCourseToUsers = async (courseId, userIds, clientId) => {
  console.log("Assigning course to users: ", courseId, userIds, clientId);
  const results = await fetch(
    `${process.env.REACT_APP_REST_SERVER_URL}/admin/courses/${clientId}/course/${courseId}/assign`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
      body: JSON.stringify({ user_ids: userIds }),
    }
  );
  const response = await results.json();
  return response;
}

export const updateQuestion = async (updatedQuestion) => {
  const { public_id } = updatedQuestion;
  const results = await fetch(
    `${process.env.REACT_APP_REST_SERVER_URL}/admin/courses/question/update/${public_id}`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
      body: JSON.stringify(updatedQuestion),
    }
  );
  const response = results.json();
  return response;
}

export const updateFAQ = async (updatedFAQGroup, updatedFAQQuestion) => {
  const results = await fetch(
    `${process.env.REACT_APP_REST_SERVER_URL}/admin/courses/faq/update`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
      body: JSON.stringify({ question: updatedFAQQuestion, group: updatedFAQGroup }),
    }
  );
  const response = results.json();
  return response;
}

export const updateContentBlock = async (updatedBlock) => {
  const { public_id, short_title, content, image_data } = updatedBlock;
  const results = await fetch(
    `${process.env.REACT_APP_REST_SERVER_URL}/admin/courses/contentblock/update/${public_id}`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
      body: JSON.stringify({ short_title, content, image_data }),
    }
  );
  const response = results.json();
  return response;
}

export const checkForContentBlockSpeechURL = async (contentBlockId) => {
  console.log("Checking for speech URL for content block: ", contentBlockId);
  const results = await fetch(
    `${process.env.REACT_APP_REST_SERVER_URL}/admin/courses/contentblock/${contentBlockId}/checkforspeech`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
    }
  );
  const response = await results.json();
  return response;
}

export const getContentStatuses = async (courseId) => {
  const results = await fetch(
    `${process.env.REACT_APP_REST_SERVER_URL}/admin/courses/statuses/${courseId}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
    }
  );
  const response = await results.json();
  return response;
}

export const addContentStatusResponse = async (contentStatusId, resolved, comment) => {
  const results = await fetch(
    `${process.env.REACT_APP_REST_SERVER_URL}/admin/courses/statuses/response/${contentStatusId}`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
      body: JSON.stringify({ resolved, comment }),
    }
  );
  const response = await results.json();
  return response;
}

export const updateLevel = async (updatedLevel) => {
  const { public_id, title, description, short_description } = updatedLevel;
  const results = await fetch(
    `${process.env.REACT_APP_REST_SERVER_URL}/admin/courses/level/update/${public_id}`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
      body: JSON.stringify({ title, description, short_description }),
    }
  );
  const response = results.json();
  return response;
}

export const updateSection = async (updatedSection) => {
  const { public_id, title, description, short_description } = updatedSection;
  const results = await fetch(
    `${process.env.REACT_APP_REST_SERVER_URL}/admin/courses/section/update/${public_id}`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
      body: JSON.stringify({ title, description, short_description }),
    }
  );
  const response = results.json();
  return response;
}

export const deleteQuestion = async (questionId) => {
  console.log("!!! DELETE QUESTION: ", questionId);
  const results = await fetch(
    `${process.env.REACT_APP_REST_SERVER_URL}/admin/courses/question/${questionId}`,
    {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
    }
  );
  const response = results.json();
  return response;
}

export const deleteBlock = async (blockId) => {
  console.log("!!! DELETE BLOCK: ", blockId);
  const results = await fetch(
    `${process.env.REACT_APP_REST_SERVER_URL}/admin/courses/contentblock/${blockId}`,
    {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
    }
  );
  const response = results.json();
  return response;
}

export const updateTip = async (updatedTip) => {
  const { public_id, tip } = updatedTip;
  const results = await fetch(
    `${process.env.REACT_APP_REST_SERVER_URL}/admin/courses/tip/${public_id}`,
    {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
      body: JSON.stringify({ tip }),
    }
  );
  const response = results.json();
  return response;
}

export const deleteTip = async (tipId) => {
  console.log("!!! DELETE TIP: ", tipId);
  const results = await fetch(
    `${process.env.REACT_APP_REST_SERVER_URL}/admin/courses/tip/${tipId}`,
    {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
    }
  );
  const response = results.json();
  return response;
}
